import { fetchCreditReturnsStatusStatistics } from '@/services/creditReturns'
import { FTWebSocket } from '@/utils/FTWebSocket'

/**
 * Mutation types of the store
 */
const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED',
  SET_COUNTERS: 'SET_COUNTERS',
  UPDATE_COUNTERS: 'UPDATE_COUNTERS',
  UPDATE_OUTSTANDING_COUNT: 'UPDATE_OUTSTANDING_COUNT'
}

/**
 * Initial state
 */
const state = {
  loading: false,
  fetching: false,
  counters: {
    acceptedCount: 0,
    outstandingCount: 0,
    rejectedCount: 0,
    totalCount: 0
  }
}

/**
 * Getters
 */
const getters = {
  approvedCreditReturns(state) {
    return state.counters.acceptedCount
  },

  outstandingCreditReturns(state) {
    return state.counters.outstandingCount
  },

  rejectedCreditReturns(state) {
    return state.counters.rejectedCount
  }
}

/**
 * Actions
 */
const actions = {
  /**
   * @desc Fetch total of order queries
   */
  fetchCreditReturnsStatusStatistics({ commit }) {
    commit(mutationTypes.FETCHING)
    return fetchCreditReturnsStatusStatistics().then((response) => {
      commit(mutationTypes.FETCHED)
      commit(mutationTypes.SET_COUNTERS, response)
    })
  },

  updateOutstandingCount({ commit }, outstandingCount) {
    commit(mutationTypes.UPDATE_OUTSTANDING_COUNT, outstandingCount)
  },

  subscribeToCreditReturns({ commit, dispatch, rootState }) {
    return FTWebSocket.subscribe(
      '/user/queue/credit-returns/new',
      (counters) => {
        const selectedSupplierId = rootState?.preferences?.selectedSupplierId
        // websocket sends events for all suppliers linked to user account
        // we need to only update counter if event relates to selected supplier
        if (counters.supplierId === selectedSupplierId) {
          console.log('Received credit return websocket notification', counters)
          commit(mutationTypes.UPDATE_COUNTERS, counters)

          let text
          const updatedItem = counters.updatedItems?.[0]?.referenceNumber || ''

          if (counters?.newOutstandingCount === 1)
            text = `Credit Return ${updatedItem} has been received.`
          else if (counters?.newAcceptedCount === 1)
            text = `Credit Return ${updatedItem} has been ACCEPTED.`
          else if (counters?.newRejectedCount === 1)
            text = `Credit Return ${updatedItem} has been REJECTED.`

          dispatch(
            'notifications/addNotification',
            {
              color: 'warning',
              closable: true,
              text,
              timeout: -1
            },
            { root: true }
          )
        }
      }
    )
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING](state) {
    state.fetching = true
    state.loading = true
  },

  [mutationTypes.FETCHED](state) {
    state.fetching = false
    state.loading = false
  },

  [mutationTypes.SET_COUNTERS](state, counters) {
    state.counters = { ...counters }
  },

  [mutationTypes.UPDATE_COUNTERS](state, counters) {
    const acceptedCount =
      state.counters.acceptedCount + counters.newAcceptedCount
    const outstandingCount =
      state.counters.outstandingCount + counters.newOutstandingCount
    const rejectedCount =
      state.counters.rejectedCount + counters.newRejectedCount
    state.counters = {
      acceptedCount,
      outstandingCount,
      rejectedCount,
      totalCount: acceptedCount + outstandingCount + rejectedCount
    }
  },

  [mutationTypes.UPDATE_OUTSTANDING_COUNT](state, outstandingCount) {
    state.counters.outstandingCount = outstandingCount
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
